// material-ui
import MuiGlobalStyles from '@mui/material/GlobalStyles';

// ==============================|| THEME - GLOBAL STYLE  ||============================== //

export default function GlobalStyles() {
  return (
    <MuiGlobalStyles
      styles={(theme) => ({
        // global-style -> apexcharts
        '.apexcharts-theme-dark .apexcharts-menu': {
          borderColor: theme.vars.palette.text.secondary,
          color: theme.vars.palette.text.primary,
          '& .apexcharts-menu-item:hover': {
            color: theme.vars.palette.primary.main
          }
        },
        '.shims-w-32': {
          width: "32px"
        },
        '.shims-border-1': {
          border: "1px solid black"
        },
        '.shims-w-30': {
          width: "30px"
        },
        '.shims-w-23': {
          width: "23px"
        },
        '.shims-w-100p': {
          width: "100%"
        },
        '.shims-w-60p': {
          width: "60%"
        },
        '.shims-w-100px': {
          width: "100px"
        },
        '.shims-mb-20': {
          marginBottom: "20px"
        },
        '.shims-mt-10': {
          marginTop: "10px"
        },
        '.shims-mr-5': {
          marginRight: "5px"
        },
        '.shims-bold': {
          fontWeight: "bold",
        },
        '.shims-color-red-bold': {
          color: "red",
          fontWeight: "bold",
        },
        '.shims-color-green-bold': {
          color: "green",
          fontWeight: "bold",
        },
        '.shims-hidden': {
          display: 'none !important',
        }
      })}
    />
  );
}
